// Collapse the long SEO text section on collection pages behind one read-more toggle
(function () {
  function init() {
    var strings = window.neaStrings || {};
    document.querySelectorAll('.shopify-section[id*="custom_content"]').forEach(function (section) {
      var el = section.querySelector('.m-custom-content__wrapper');
      if (!el || el.dataset.neaClamp || el.scrollHeight < 420) return;
      el.dataset.neaClamp = '1';
      el.classList.add('nea-clamp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nea-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = strings.readMore || 'Read more';
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? (strings.readLess || 'Read less') : (strings.readMore || 'Read more');
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
